// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__JOefV","dragIcon":"Choice_dragIcon__1tbPv","left":"Choice_left__yb413","input":"Choice_input__1NXlA"};